module.exports = __webpack_public_path__ + "media/src/images/drag_dark-d54f5688c81c66a548bbfd41cd105987.png";